import { Auth } from 'aws-amplify'
import config from 'src/config'

export const uploadFile = async selectedFile => {
  const session = await Auth.currentSession()
  const token = session.getAccessToken().getJwtToken()

  const formData = new FormData()
  formData.append('file', selectedFile)

  try {
    const response = await fetch(
      `${config.apiGateway.EXPRESS_URL}files/uploadFile`,
      {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: `${token}`,
        },
      },
    )

    const res = await response.json()
    if (res.success) {
      return res.data
    }
  } catch (error) {
    console.error('Error uploading file:', error)
  }
}

export const deleteFile = async fileKey => {
  if (!fileKey) return

  try {
    const encodedKey = encodeURIComponent(fileKey)
    const session = await Auth.currentSession()
    const token = session.getAccessToken().getJwtToken()
    const directResponse = await fetch(
      `${config.apiGateway.EXPRESS_URL}files/deleteFile/${encodedKey}`,
      {
        method: 'DELETE',
        headers: {
          Authorization: `${token}`,
        },
      },
    )

    const payloadText = await directResponse.text()
    let payload = null
    try {
      payload = payloadText ? JSON.parse(payloadText) : null
    } catch {
      payload = null
    }

    if (directResponse.ok && payload?.success) {
      return { success: true, error: null }
    }

    return {
      success: false,
      error:
        payload?.message ||
        `Delete failed (${directResponse.status} ${directResponse.statusText})`,
    }
  } catch (error) {
    console.error('Error deleting file:', error)
    return {
      success: false,
      error: error?.message || 'Failed to delete file',
    }
  }
}

// get file URL from S3
export const getFileUrl = async fileKey => {
  if (!fileKey) return null

  try {
    const encodedKey = encodeURIComponent(fileKey)
    return `${config.apiGateway.EXPRESS_URL}files/${encodedKey}`
  } catch (error) {
    console.error('Error getting file URL:', error)
    return null
  }
}
